$(document).ready(function() {
    const form = $('#formAuthentication');

    $('input').on('change',function(){
        $(this).removeClass('is-invalid');
    });
    
    // Form validation
    form.on('submit', function(e) {
        e.preventDefault();
        
        let isValid = true;
        const errorMessages = {
            username: 'Username is required and must be at least 3 characters',
            email: 'Please enter a valid email address',
            password: 'Password must be at least 6 characters long',
            terms: 'You must agree to the terms and conditions'
        };
        
        // Clear previous error messages
        $('.is-invalid').removeClass('is-invalid');
        
        // Validate username
        const username = $('#username').val().trim();
        if (username.length < 3) {
            $('#username').addClass('is-invalid');
            isValid = false;
        }
        
        // Validate email
        const email = $('#email').val().trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            $('#email').addClass('is-invalid');
            isValid = false;
        }
        
        // Validate password
        const password = $('#password').val();
        if (password.length < 6) {
            $('#password').addClass('is-invalid');
            isValid = false;
        }
        
        // Validate terms
        if (!$('#terms-conditions').is(':checked')) {
            $('#terms-conditions').addClass('is-invalid');
            isValid = false;
        }
        
        // If form is valid, submit via AJAX
        if (isValid) {
            $.ajax({
                type: 'POST',
                url: '/register',
                data: form.serialize(),
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        // Show success message and redirect
                        $('<div class="alert alert-success mt-3">' + response.message + '</div>').insertBefore(form);
                        document.cookie = "register_email="+$('#email').val().trim()+"; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
                        setTimeout(function() {
                            window.location.href = response.redirect || '/login';
                        }, 2000);
                    } else {
                        // Show error message
                        $('#form-error').html('<div class="alert alert-danger mt-3">' + response.message + '</div>');
                    }
                },
                error: function() {
                    $('<div class="alert alert-danger mt-3">An error occurred. Please try again later.</div>').insertBefore(form);
                }
            });
        }
    });
    
    // Toggle password visibility
    $('.input-group-text').on('click', function() {
        const passwordInput = $(this).siblings('input');
        const icon = $(this).find('i');
        
        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            icon.removeClass('bx-hide').addClass('bx-show');
        } else {
            passwordInput.attr('type', 'password');
            icon.removeClass('bx-show').addClass('bx-hide');
        }
    });
});